import { useEffect, useState } from "react";

import { useActionHook } from "hooks/shared-hooks/use-action-hook";
import { isArray } from "lodash";
import { useDealActions } from "store";

export function useDealInvestorsHook(deal_id: number | undefined) {
  const { getDealInvestors } = useDealActions();
  const [dealInvestors, setDealInvestors] = useState<{ id: number; name: string }[]>([]);

  const { action: getDealInvestorsAction } = useActionHook(
    () => (deal_id ? getDealInvestors({ dealId: deal_id }) : Promise.resolve([])),
    {
      onSuccess: (data) => {
        const investors = isArray(data) ? data.map((item) => ({ id: item.id, name: item.name })) : [];
        setDealInvestors(investors);
      }
    }
  );
  useEffect(() => {
    getDealInvestorsAction();
  }, []);

  return {
    dealInvestors,
    refetchInvestors: getDealInvestorsAction
  };
}
